import { Banner } from '@lmc/design-system'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'

const SafeguardingBanner = () => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <Banner type="warning">
      {t(incidentReportsConstants.SAFEGUARDING_BANNER)}
    </Banner>
  )
}

export default SafeguardingBanner
